import { render, staticRenderFns } from "./participating-insurers.vue?vue&type=template&id=76f523e8&"
import script from "./participating-insurers.vue?vue&type=script&lang=js&"
export * from "./participating-insurers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports